import { Modal, ModalDialog, ModalClose } from "@mui/joy";
import PriceCalculator from "../../blocks/PriceCalculator";

// Модалка калькулятора для ЛК: переиспользует калькулятор лендинга в режиме embedded.
export default function CalculatorModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        layout="center"
        sx={{
          p: 0,
          width: "min(1100px, 96vw)",
          maxWidth: "96vw",
          maxHeight: "92vh",
          overflow: "auto",
          border: "none",
          background: "transparent",
          boxShadow: "none",
        }}
      >
        <ModalClose
          sx={{
            zIndex: 2,
            color: "#fff",
            bgcolor: "rgba(255,255,255,0.08)",
            "&:hover": { bgcolor: "rgba(255,255,255,0.18)" },
          }}
        />
        <PriceCalculator embedded onClose={onClose} />
      </ModalDialog>
    </Modal>
  );
}